import { render, staticRenderFns } from "./PanelCookies.vue?vue&type=template&id=c1a76f44&scoped=true"
import script from "./PanelCookies.vue?vue&type=script&lang=js"
export * from "./PanelCookies.vue?vue&type=script&lang=js"
import style0 from "./PanelCookies.vue?vue&type=style&index=0&id=c1a76f44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a76f44",
  null
  
)

/* custom blocks */
import block0 from "./PanelCookies.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports